// Tooltip copy shared by the trial usage meters: the sidebar TrialProgress widget
// and the in-editor TrialUsageMeters. Kept here so both surfaces stay in sync.

export const PERFORMANCE_PREDICTIONS_USAGE_TOOLTIP =
  'Performance predictions show how effective your copy will be before it’s published. Upgrade to get more.';

export const getWordCreditsUsageTooltip = (wordsLimit: number): string =>
  `Generate up to ${wordsLimit} words in this trial. Upgrade to get more.`;
